module.exports = __webpack_public_path__ + "static/media/43_RobinLelgemann_webfinal.0a2c8eab.jpg";